export function firstPreviewUrl(text) {
  const match = String(text || "").match(/https?:\/\/[^\s>"'<]+/i)
  if (!match) return null
  return match[0].replace(/[),.!?:;]+$/, "") || null
}
